import {cart} from 'app/cart';
import {addToCart, changeItem} from 'cart';
import {formatMoney} from 'utils';

export function CartDrawerApp() {
  return {
    cart,
    isLoading: false,
    async modifyCart(func, ...args) {
      this.isLoading = true;
      await func(...args);
      this.isLoading = false;
    },
    async handleItemChange(event) {
      await this.modifyCart(changeItem, event);
    },
    async handleAddToCart(event) {
      await this.modifyCart(addToCart, event);
    },
    formattedMoney(money) {
      return formatMoney(money);
    },
    getProperties(item) {
      if (!item.url.includes('custom')) {
        return ''; // Return empty string if "custom" is not in the title
      }
      const availableItems = item.custom_properties ?? item.properties;
      const propertiesString = Object.entries(availableItems)
        .filter(([key]) => key !== '_unique_id') // Skip '_unique_id' property
        .map(([key, value]) => `${key} ${value}`)
        .join(' / ');
      return propertiesString ? ` / ${propertiesString}` : '';
    },
    $delimiters: ['${', '}$'],
  };
}
